import styled, { keyframes, css } from 'styled-components';
import { InProgress } from "../Icons";

const RotateAnimation = /*#__PURE__*/keyframes(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);








const AnimatedInProgressIcon = /*#__PURE__*/styled(InProgress).withConfig({ displayName: "styles__AnimatedInProgressIcon", componentId: "sc-17prjwv-0" })(["animation:", " 2s linear infinite;"],
RotateAnimation);


const Container = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__Container", componentId: "sc-17prjwv-1" })(["display:flex;align-items:center;flex-wrap:nowrap;"]);





const Text = /*#__PURE__*/styled.span.withConfig({ displayName: "styles__Text", componentId: "sc-17prjwv-2" })(["flex:auto;color:", ";", " text-overflow:ellipsis;overflow:hidden;white-space:nowrap;"],

({ color, theme }) => color || theme.colors['Level 4'],
(props) => css(props.theme.typography.Paragraph));





const IconWrap = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__IconWrap", componentId: "sc-17prjwv-3" })(["flex:none;display:flex;margin-right:", ";"],


(props) => props.theme.spacers.M);


export { Container, Text, IconWrap, AnimatedInProgressIcon };